export enum ResponseHeaders {
  ContentRange = 'content-range',
}
